<script lang='ts'>
    import { getContext } from "svelte";
    import WeekAvailability from "@/SetupWizards/WeekAvailability.svelte";
    import MovingTimeSettings from "../Program/ProgramElements/MovingTimeSettings.svelte";
    import DurabilityMetricSettings from "@/Program/ProgramElements/DurabilityMetricSettings.svelte";
    import HeartRateDerivedMetrics from "./HeartRateDerivedMetrics.svelte";
    import { MyFitnessStores, type MedianAndWeatherStores } from "./stores";
    import type { TrainingPlanSettings } from "@/Common/constants";
    import XfaiGeneralSettings from "../Program/ProgramElements/XfaiGeneralSettings.svelte";
    import { InfoIcon } from "@/Common";
    import { WeeklyHoursSlider, ProgramDifficultySlider } from "@/Program/ProgramElements/SetupFormInputs";


    const { cal_settings, trainingPlan, userParams } = getContext<MyFitnessStores>('myFitness')
    const { trainingMedians } = getContext<MedianAndWeatherStores>('medianAndWeather')

    export let profileParams: any
    // Whether any of its sections has been edited since it was shown or last saved
    export let changed = false
    let movingTimeChanged = false, durabilityChanged = false, heartRateChanged = false
    $: changed = movingTimeChanged || durabilityChanged || heartRateChanged
    // For bind
    export let settings: TrainingPlanSettings
    // Live difficulty computed from the user's current training load (same value the Today
    // card's difficulty_rating uses), shown in place of the stored setting while "Based on
    // Training Load" is on.
    export let calculatedDifficulty: number = undefined
    let heartRateDerivedMetrics
    let movingTimeSettings
    let durabilityMetricSettings
    export const submitHandler = () => Promise.all([heartRateDerivedMetrics?.submitHandler(), movingTimeSettings?.submitHandler(), durabilityMetricSettings?.submitHandler()])

    $: durabilityFeatureEnabled = $userParams?.features?.includes('durabilityMetric') ?? false
</script>

<!-- Cal Settings will be saved by ProfileSettings.svelte@updateSettings -->
<div class="flex flex-col gap-4">
    <!-- The week's availability, as on the account setup wizard: a day opens its availability to change it -->
    <div class="flex flex-col gap-3 py-2 px-4 pb-4 border border-solid border-black/10 rounded">
        <div class="flex items-baseline pt-2">
            <h4 class="mr-auto">Weekly Availability</h4>
            <span class="text-xs text-slate-400">Tap a day to change it</span>
        </div>
        {#if $cal_settings && $trainingMedians}
            <WeekAvailability bind:defaults={$cal_settings.defaults} trainingMedians={$trainingMedians}/>
        {/if}
    </div>
    <MovingTimeSettings bind:this={movingTimeSettings} bind:changed={movingTimeChanged} bind:cal_settings={$cal_settings} alwaysOpen={true} />
    {#if durabilityFeatureEnabled}
    <DurabilityMetricSettings bind:this={durabilityMetricSettings} bind:changed={durabilityChanged} bind:cal_settings={$cal_settings} alwaysOpen={true} />
    {/if}
</div>

<div class="flex flex-col gap-4">
    <HeartRateDerivedMetrics bind:this={heartRateDerivedMetrics} bind:changed={heartRateChanged} {profileParams} ></HeartRateDerivedMetrics>

    <XfaiGeneralSettings bind:settings {calculatedDifficulty} alwaysOpen={true} showDefaultsButton={false}>
        <span class="text-slate-600 text-sm">Max Weekly Hours</span>
        <WeeklyHoursSlider
            bind:hours={settings.maxWeeklyHours}
        />
    </XfaiGeneralSettings>
</div>

<style lang="scss">
    .settings-container {
        display: flex;
        flex-direction: column;
        padding: 20px;
        gap: 5px;
        .slider-container {
            align-self: baseline;
            display: flex;
            max-width: 100%;
            width: 100%;
            align-items: center;
            
            &.difficulty-slider-grid {
                display: grid;
                grid-template-columns: auto min-content;
            }
        }
        .settings-slider-label {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        }
    }
</style>